import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import ApiMakerTable from "shared/api-maker-table"
import classNames from "classnames"
import {ContactEmail} from "models"
import ContactLink from "components/contacts/link"
import linkProps from "shared/link-props"
import memo from "set-state-compare/src/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default memo(shapeComponent(class ComponentsContactEmailsTable extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {columns, editModelPath} = this.tt
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--contact-emails--table", className)}
        columns={columns}
        editModelPath={editModelPath}
        modelClass={ContactEmail}
        preload={["contact"]}
        select={{
          Contact: ["id"],
          ContactEmail: ["id"]
        }}
        {...restProps}
      />
    )
  }

  columns = () => [
    {
      attribute: "id",
      defaultVisible: false,
      sortKey: "id"
    },
    {
      attribute: "name",
      content: this.tt.contactContent,
      label: ContactEmail.humanAttributeName("contact"),
      path: ["contact"],
      sortKey: "contactName"
    },
    {
      attribute: "email",
      sortKey: "email"
    },
    {
      attribute: "primary",
      sortKey: "primary"
    },
    {
      attribute: "createdAt",
      sortKey: "createdAt"
    }
  ]

  childContent = ({contactEmail}) => <ContactLink adminLayout contact={contactEmail.child()} />
  contactContent = ({contactEmail}) => contactEmail.contact() && <ContactLink contact={contactEmail.contact()} {...linkProps(this.props)} />

  editModelPath = ({contactEmail}) => {
    if (this.p.adminLayout) return Routes.editAdminContactEmailPath(contactEmail.id())
  }
}))
